import { useRef } from 'react';
import { isEqual } from '../utils/isEqual';

export const useDeepMemo = <T>(value: T): T => {
  const ref = useRef(value);

  if (!isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
};
